import React, { createContext, useState } from "react";

export const GlobalContext = createContext({})

export default function GlobalProvider({ children }) {
    const [loading, setLoading] = useState({ show: false, message: "" })
    const [showAlert, setShowAlert] = useState({});

    return <GlobalContext.Provider value={{
        loading, setLoading,
        showAlert, setShowAlert
    }}>
        {children}
    </GlobalContext.Provider>
}